import React, { useEffect, useMemo, useState } from 'react';
import FeatureRequestForm from '../../components/FeatureRequestForm';
import ScreenshotEditor from '../../components/ScreenshotEditor';

const FeatureRequestPopout: React.FC = () => {
  const [screenshotImage, setScreenshotImage] = useState<string | null>(null);
  const [screenshotUpdateCallback, setScreenshotUpdateCallback] =
    useState<((newImage: string) => void) | null>(null);

  const openerUrl = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('from') || undefined;
  }, []);

  useEffect(() => {
    document.title = 'Request a Feature';
  }, []);

  // html/body/#root are pinned to 100vh with overflow hidden (App.css), so this page owns its
  // own scroll container — otherwise the Submit button below the fold is unreachable.
  return (
    <div className="h-screen w-full overflow-y-auto bg-theme-bg-primary text-heading">
      <div className="mx-auto max-w-3xl pb-6">
        <FeatureRequestForm
          isOpen={true}
          onCancel={() => window.close()}
          initialPageUrl={openerUrl}
          onShowScreenshotModal={(screenshot, updateCallback) => {
            setScreenshotImage(screenshot);
            setScreenshotUpdateCallback(() => updateCallback);
          }}
        />
      </div>

      <ScreenshotEditor
        isOpen={!!screenshotImage}
        imageData={screenshotImage || ''}
        onClose={() => {
          setScreenshotImage(null);
          setScreenshotUpdateCallback(null);
        }}
        onApply={(editedImageData) => {
          if (screenshotUpdateCallback) {
            screenshotUpdateCallback(editedImageData);
          }
          setScreenshotImage(null);
          setScreenshotUpdateCallback(null);
        }}
      />
    </div>
  );
};

export default FeatureRequestPopout;
